import { useEffect, useState } from 'react';

// Mine / Everyone toggle, persisted to localStorage so a rep's choice
// survives reloads + tab swaps. Used on Sends, Audiences, and the
// dashboard's recent-activity feed.
export function useScope(storageKey, defaultValue = 'mine') {
  const [scope, setScope] = useState(() => {
    if (typeof localStorage === 'undefined') return defaultValue;
    try { return localStorage.getItem(storageKey) || defaultValue; }
    catch { return defaultValue; }
  });
  useEffect(() => {
    try { localStorage.setItem(storageKey, scope); } catch { /* ignore */ }
  }, [storageKey, scope]);
  return [scope, setScope];
}

// Scope a list of {createdBy} items to the current user's email when
// scope === 'mine'. Returns the unchanged list when scope === 'all'.
export function scopeItems(items, scope, currentEmail) {
  if (scope !== 'mine') return items;
  if (!currentEmail) return items;
  const lc = currentEmail.toLowerCase();
  return items.filter((i) => (i.createdBy || '').toLowerCase() === lc);
}

export default function ScopeToggle({ scope, onChange, mineCount, allCount, mineLabel = 'Mine', allLabel = 'Everyone' }) {
  return (
    <div className="inline-flex rounded-full bg-gray-100 dark:bg-gray-800 p-0.5 text-sm">
      <ScopeButton
        active={scope === 'mine'}
        onClick={() => onChange('mine')}
        label={mineLabel}
        count={mineCount}
      />
      <ScopeButton
        active={scope === 'all'}
        onClick={() => onChange('all')}
        label={allLabel}
        count={allCount}
      />
    </div>
  );
}

function ScopeButton({ active, onClick, label, count }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-3 py-1 rounded-full transition flex items-center gap-1.5 ${
        active
          ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 shadow-sm font-medium'
          : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'
      }`}
    >
      <span>{label}</span>
      {count != null && (
        <span className={`text-xs tabular-nums ${active ? 'text-gray-500 dark:text-gray-400' : 'text-gray-400'}`}>
          {count.toLocaleString()}
        </span>
      )}
    </button>
  );
}
